import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import Moment from 'react-moment';
import Table from '../../../../../../components/table/Table';

export default class NMR extends Component {
    render() {
        if (this.props.details.length > 0) {
            return (
                <Row>
                    <Col md="12">
                        <Table responsive className="table--bordered hpi">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Code</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.details.map((item, i) => (
                                    <tr key={item._id}>
                                        <td>{i + 1}</td>
                                        <td>{item.sub_source_of_mileage}</td>
                                        <td>{item.source_of_mileage}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                    </Col>
                </Row>
            );
        }
        return (<Row><Col md="12"><p>There are no records about any NMR discrepancies</p></Col></Row>);
    }
}

NMR.propTypes = {
    details: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/HPI_components/nmr.js